var map = {
	"./AuthView.layout.vue": 4866,
	"./ChatView.layout.vue": 438,
	"./DefaultLayout.vue": 427,
	"./DefaultViewLayout.vue": 607,
	"./MarketplaceLayout.vue": 8335,
	"./NewsContent.layout.vue": 8203
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 275;